import { render, staticRenderFns } from "./InviteAdmin.vue?vue&type=template&id=608b8480&"
import script from "./InviteAdmin.vue?vue&type=script&lang=js&"
export * from "./InviteAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports